exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Ij4LT6q5lCOZyWWBiYjSu{cursor:default;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;font-size:14px;font-weight:400;font-weight:600;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] .Ij4LT6q5lCOZyWWBiYjSu{background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\";margin-bottom:1px}", ""]);

// exports
exports.locals = {
	"outerContainer": "Ij4LT6q5lCOZyWWBiYjSu"
};